import { isValidSource } from '@utils/sundries'
import I18n from '@utils/i18n';
import xss, { whiteList } from 'xss';

const DEL_ATTRS = [
  'onAbort', 'onActivate', 'onAfterPrint', 'onAfterUpdate', 'onBeforeActivate', 'onBeforeCopy', 'onBeforeCut',
  'onBeforeDeactivate',
  'onBeforeEditFocus', 'onBeforePaste', 'onBeforePrint', 'onBeforeUnload', 'onBeforeUpdate', 'onBegin', 'onBlur', 'onBounce',
  'onCellChange', 'onChange', 'onClick', 'onContextMenu', 'onControlSelect', 'onCopy', 'onCut', 'onDataAvailable',
  'onDataSetChanged',
  'onDataSetComplete', 'onDblClick', 'onDeactivate', 'onDrag', 'onDragEnd', 'onDragLeave', 'onDragEnter', 'onDragOver',
  'onDragDrop',
  'onDragStart', 'onDrop', 'onEnd', 'onError', 'onErrorUpdate', 'onFilterChange', 'onFinish', 'onFocus', 'onFocusIn',
  'onFocusOut',
  'onHashChange', 'onHelp', 'onInput', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onLayoutComplete', 'onLoad', 'onLoseCapture',
  'onMediaComplete', 'onMediaError', 'onMessage', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut',
  'onMouseOver', 'onMouseUp', 'onMouseWheel', 'onMove', 'onMoveEnd', 'onMoveStart', 'onOffline', 'onOnline', 'onOutOfSync',
  'onPaste',
  'onPause', 'onPopState', 'onProgress', 'onPropertyChange', 'onReadyStateChange', 'onRedo', 'onRepeat', 'onReset', 'onResize',
  'onResizeEnd', 'onResizeStart', 'onResume', 'onReverse', 'onRowsEnter', 'onRowExit', 'onRowDelete', 'onRowInserted', 'onScroll',
  'onSeek', 'onSelect', 'onSelectionChange', 'onSelectStart', 'onStart', 'onStop', 'onStorage', 'onSyncRestored', 'onSubmit',
  'onTimeError', 'onTrackChange', 'onUndo', 'onUnload', 'onURLFlip', 'style', 'class', 'onclick', 'onmousedown', 'onmouseup',
  'onmouseover', 'onmouseout', 'onmousemove', 'contentEditable', 'tabindex', 'onkeydown', 'onkeypress', 'onkeyup', 'onload',
  'onready', 'onerror', 'seekSegmentTime', 'FSCommand', 'ontouchstart', 'ontouchend', 'ontouchmove']

const getDom = (html) => {
  let el
  if (typeof window !== 'undefined') {
    el = document.createElement('div');
    el.innerHTML = html;
  } else {
    const { JSDOM } = require('jsdom');
    const dom = new JSDOM(`<!DOCTYPE html><div id='container'>${html}</div>`)
    el = dom.window.document.querySelector('#container')
  }
  return el
}

const updateVideoEl = (el, isValid) => {
  const video = el.outerHTML;
  let div;
  if (isValid) {
    div = getDom(`
      <div class="post-video-container video-react">
        <div class="video-react-button video-react-big-play-button video-react-big-play-button-center post-play-btn">
          <span class="video-react-control-text" />
        </div>
        ${video}
      </div>
    `)
    return div.querySelector('*')
  }
  const tip = I18n.t('WIl74u8P')
  div = getDom(`<!-- ${tip} -->`)
  return div.firstChild;
}

const updateImgEl = () => {
  // 22.09.15 需求更改 将不符合规定的图片资源
  const tip = I18n.t('Kmmg8uqw')
  const div = getDom(`<!-- ${tip} -->`)
  return div.firstChild
}

const getVideoSrcAndDelIllegalNode = (el) => {
  const src = el.src;
  if (src) {
    return [src]
  }
  const source = el.querySelectorAll('source')
  if (!source?.length) {
    return []
  }
  const srcList = [];
  [...source].forEach(item => {
    if (isValidSource(src, 'video')) {
      srcList.push(item.src)
    } else {
      el.replaceChild(updateVideoEl())
    }
  })
  return srcList
}

const updatePictureNode = (el) => {
  const source = el.querySelectorAll('source');
  const img = el.querySelectorAll('img');

  [...source, ...img].forEach(item => {
    const src = item.srcset || item.src
    if (!isValidSource(src, 'image')) {
      el.replaceChild(updateImgEl(item, false), item)
    }
  })
}

const deleteHtmlAttr = (el) => {
  if (el.nodeType !== 1) {
    return
  }

  DEL_ATTRS.forEach(attr => {
    el.removeAttribute(attr);
  });

  [...el.childNodes].forEach(node => {
    if (['SCRIPT', 'INPUT', 'FORM', 'TEXTAREA', 'SELECT', 'BUTTON', 'AUDIO', 'META', 'LINK', 'TITLE'].includes(node.tagName)) {
      el.removeChild(node)
      return
    }
    if (['IMG'].includes(node.tagName)) {
      if (!isValidSource(node.src, 'image')) {
        el.replaceChild(updateImgEl(), node)
        return
      }
    }
    if (['PICTURE'].includes(node.tagName)) {
      updatePictureNode(node)
      return
    }
    if (['VIDEO'].includes(node.tagName)) {
      node.removeAttribute('controls');
      const srcList = getVideoSrcAndDelIllegalNode(node);
      const validRes = srcList.every(src => isValidSource(src, 'video')) && !!srcList?.length
      el.replaceChild(updateVideoEl(node, validRes), node)
      return
    }
    if (['A'].includes(node.tagName) && node.href) {
      const url = new URL(node.href)
      if (!['http:', 'https:'].includes(url.protocol)) {
        node.href = 'javascript:;'
      }
    }
    if (!el.childNodes.length) {
      return
    }
    deleteHtmlAttr(node, el)
  })
}

const getImages = (el) => {
  const imgs = el.querySelectorAll('img');
  return [...imgs].map(img => img.src)
}

const expandWhiteList = {
  ...whiteList,
  picture: [],
  source: []
}

export const parseHtml = (html) => {
  const el = getDom(html?.replace(/(&lt;|&gt;)/gi, ($0, $1) => {
    return {
      '&lt;': '<',
      '&gt;': '>'
    }[$1]
  }))
  deleteHtmlAttr(el)
  const imgSrcGroup = getImages(el)
  const htmlText = xss(el.outerHTML, { whiteList: expandWhiteList })
  return {
    imgSrcGroup,
    htmlText
  }
}
